const { debounce } = window.BAO.Utils
const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class CollectionStorytellingCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    this.checkSetupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.destroyCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.checkSetupCarousel()
      }, 500),
    )
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy()
    this.carousel = null
    this.els?.slides?.element?.removeAttribute('data-initialised')
  }

  checkSetupCarousel () {
    if (window.innerWidth >= 1280) {
      this.destroyCarousel();

      return;
    }

    if (!this.carousel) {
      this.carousel = this.setupCarousel()
    } else {
      this.carousel.update()
    }
  }

  setupCarousel () {
    const slidesEl = this.els.slides.element
    const carouselPerView = slidesEl.style.getPropertyValue('--Carousel_PerView') || 1.15
    const carouselSpacing = slidesEl.style.getPropertyValue('--Carousel_Spacing') || '16px'

    return new KeenSlider(
      slidesEl,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: Number(carouselPerView),
          spacing: parseInt(carouselSpacing, 10),
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.15,
              spacing: 16,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('collection-storytelling-carousel')) {
  customElements.define('collection-storytelling-carousel', CollectionStorytellingCarousel)
}
